import Div100vh from "react-div-100vh";
import { useStores } from "../../use.store";
import { getInformationAsset } from "../../helpers";
import { observer } from "mobx-react-lite";

const Layout = ({ children, hideBgImg = false }) => {
  const { mainStore } = useStores();

  return (
    <Div100vh>
      <div className="w-full h-full flex flex-col relative">
        <div
          className={`flex-1 flex flex-col bg-cover bg-[#F9F9F9] w-full h-screen bg-cover bg-center bg-no-repeat bg-fixed relative overflow-hidden`}
          style={{
            backgroundImage: hideBgImg
              ? "none"
              : `url(
              ${getInformationAsset(
                mainStore.config,
                mainStore.appBackground,
                "./assets/images/app-bg.png"
              )}
            )`,
          }}
        >
          {children}
        </div>
      </div>
    </Div100vh>
  );
};

export default observer(Layout);
